const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://kakobuyfinds.fit';

const FAVICON_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8caf559f256f.png';

interface FAQ {
  question: string;
  answer: string;
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'KakobuyFinds',
    url: SITE_URL,
    logo: FAVICON_URL,
    description: 'Największa baza Kakobuy Spreadsheet dla użytkowników z Polski. Aktualne Kakobuy Finds, popularne produkty i bezpieczne poradniki zakupowe.',
    sameAs: [],
  };
}

export function getWebPageSchema(name: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name,
    description,
    url,
    inLanguage: 'pl',
    publisher: {
      '@type': 'Organization',
      name: 'KakobuyFinds',
      url: SITE_URL,
    },
  };
}

export function getFAQPageSchema(faqs: FAQ[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}

export function getArticleSchema(
  headline: string,
  description: string,
  url: string,
  imageUrl: string,
  datePublished: string,
  dateModified: string,
  articleSection?: string,
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    description,
    url,
    image: imageUrl,
    datePublished,
    dateModified,
    author: {
      '@type': 'Organization',
      name: 'KakobuyFinds',
      url: SITE_URL,
    },
    publisher: {
      '@type': 'Organization',
      name: 'KakobuyFinds',
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: FAVICON_URL,
      },
    },
    inLanguage: 'pl',
    ...(articleSection ? { articleSection } : {}),
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}